// https://github.com/aws-observability/aws-rum-web/blob/main/docs/cdn_commands.md

import { AwsRum } from "aws-rum-web";

export const reportAnalytics = async () => {
  const APPLICATION_ID = process.env.REACT_APP_ANALYTICS_APPLICATION_ID;
  const APPLICATION_VERSION =
    process.env.REACT_APP_ANALYTICS_APPLICATION_VERSION || "1.0.0";
  const APPLICATION_REGION =
    process.env.REACT_APP_ANALYTICS_APPLICATION_REGION || "us-east-1";

  const credentials = await getRUMCredentials();

  if (credentials) {
    credentials.expiration = new Date(credentials.expiration);
  }

  /** @type {import("aws-rum-web").AwsRumConfig} */
  const config = {
    sessionSampleRate: 100,
    endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
    telemetries: ["errors", "performance", "http"],
    allowCookies: true,
    enableXRay: true,
    enableRumClient: true,
    dispatchInterval: 1,
    identityPoolId: process.env.REACT_APP_ANALYTICS_COGNITO_IDENTITY_ID
  };
  /** @type {import("aws-rum-web").AwsRum} */
  let awsRum = typeof window !== "undefined" ? window.awsRum : null;

  if (credentials?.expiration > new Date()) {
    awsRum = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      {
        ...config,
        guestRoleArn: process.env.REACT_APP_ANALYTICS_IAM_AUTH_ROLE_ID
      }
    );
    awsRum.setAwsCredentials(credentials);
    console.log(credentials);
  } else {
    localStorage.removeItem("cwr_c");
    if (typeof awsRum?.dispatch === "function") {
      awsRum.disable();
    }
    awsRum = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      {
        ...config,
        guestRoleArn: process.env.REACT_APP_ANALYTICS_IAM_UNAUTH_ROLE_ID
      }
    );
  }
  console.log(config, awsRum);

  return awsRum;
};

/**
 *
 * @returns {Promise<AWSRUMCredentials>}
 */
async function getRUMCredentials() {
  const credentialsTxt = localStorage.getItem("cwr_c");
  return Promise.resolve()
    .then(() => (credentialsTxt ? JSON.parse(credentialsTxt) : null))
    .catch(() => null);
}

export default reportAnalytics;

/**
 * @typedef {{ accessKeyId: string, expiration: string,  secretAccessKey: string, sessionToken: string }} AWSRUMCredentials
 */
